import type { GroupKind } from '@gymcloud/mixedscript'

/**
 * What a workout holds, named and colour-coded — `/specs/design.spec.md`, Colour. A template is
 * the one place in the app where things nest inside other things, and the colour is what says
 * which kind of thing a block is at a glance. The editor and a template's page read the same
 * template, so they read it in the same words and the same colours; the values themselves are
 * the ones Android uses too.
 */

export const GROUP_LABEL: Record<GroupKind, string> = {
  superset: 'Superset',
  choose: 'Choose one',
  rotate: 'Rotate',
}

export const GROUP_TEXT: Record<GroupKind, string> = {
  superset: 'text-block-superset',
  choose: 'text-block-choose',
  rotate: 'text-block-rotate',
}
